/* ============================================================
   Holy Ice — Efectos de scroll (capa ligera, sin dependencias)
   - Stagger: retrasa en cascada los .need-animate existentes
     y aplica .he-reveal a elementos sin animación propia.
   - Parallax sutil en medias grandes (solo escritorio, rAF).
   Respeta prefers-reduced-motion y Save-Data.
   ============================================================ */
(function () {
	"use strict";

	// theme.liquid pone .he-anim en <html> (inline, sin esperar a este archivo)
	// solo si procede animar. Si no está, no tocamos nada: el contenido ya se ve.
	if (!document.documentElement.classList.contains("he-anim")) return;

	/* ---------- 1. Stagger en grids/sliders ---------- */
	// [contenedor, hijo, paso ms, tope ms]
	var STAGGER = [
		[".product-tabs__content", ".product-tabs__product", 70, 490],
		[".collection-list__row, .collection-list__slider", ".collection-list__col", 80, 480],
		[".featured-products__container", ".featured-products__col", 70, 420],
		[".best-sellers__container", ".best-sellers__column", 70, 420],
		[".collections-grid__wrapper", ".collections-grid__item", 80, 480]
	];

	// Elementos sueltos que ganan reveal propio (si no tienen need-animate)
	var SOLO = [
		".text-section__container",
		".newsletter__content",
		".footer__navigation-item",
		".product-tabs__heading-wrapper"
	];

	var io = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				entry.target.classList.add("he-in");
				io.unobserve(entry.target);
			});
		},
		{ rootMargin: "-60px 0px", threshold: 0 }
	);

	function decorate(root) {
		STAGGER.forEach(function (cfg) {
			root.querySelectorAll(cfg[0]).forEach(function (wrap) {
				var kids = wrap.querySelectorAll(cfg[1]);
				kids.forEach(function (kid, i) {
					var delay = Math.min(i * cfg[2], cfg[3]) + "ms";
					if (kid.classList.contains("need-animate")) {
						kid.style.transitionDelay = delay;
					} else if (!kid.classList.contains("he-reveal")) {
						kid.classList.add("he-reveal");
						kid.style.setProperty("--he-d", delay);
						io.observe(kid);
					}
				});
			});
		});

		SOLO.forEach(function (sel) {
			root.querySelectorAll(sel).forEach(function (el) {
				if (
					el.classList.contains("need-animate") ||
					el.classList.contains("he-reveal") ||
					el.closest(".hero-holy")
				)
					return;
				el.classList.add("he-reveal");
				io.observe(el);
			});
		});

		// Los .he-reveal escritos a mano en las secciones (coverflow, categorías…)
		// también hay que observarlos: si no, se quedan en opacity 0 para siempre.
		root.querySelectorAll(".he-reveal").forEach(function (el) {
			if (el.classList.contains("he-in")) return;
			io.observe(el);
		});
	}

	/* ---------- 2. Parallax sutil ---------- */
	var PLX_SEL =
		".featured-collection__banner-image img, " +
		".image-with-text__image-wrapper img, " +
		"[data-he-parallax] img";
	var MAX_SHIFT = 26; // px
	var plxItems = [];
	var ticking = false;

	function collectParallax(root) {
		if (!window.matchMedia("(min-width: 992px)").matches) return;
		root.querySelectorAll(PLX_SEL).forEach(function (img) {
			if (img.__hePlx) return;
			img.__hePlx = true;
			img.classList.add("he-plx");
			img.style.scale = "1.08";
			plxItems.push(img);
		});
	}

	function updateParallax() {
		ticking = false;
		var vh = window.innerHeight;
		var y = window.scrollY || 0;
		var doc = document.documentElement;
		doc.style.setProperty("--he-scroll", y);
		var max = doc.scrollHeight - vh;
		var prog = max > 0 ? y / max : 0;
		doc.style.setProperty("--he-progress", prog.toFixed(4));
		drawFuse(prog);
		plxItems.forEach(function (img) {
			var r = img.getBoundingClientRect();
			if (r.bottom < -60 || r.top > vh + 60) return;
			// -1 (arriba) → 1 (abajo) respecto al centro del viewport
			var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
			img.style.setProperty("--he-plx", (-p * MAX_SHIFT).toFixed(1) + "px");
		});
	}

	function onScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(updateParallax);
	}

	/* ---------- 3. Mecha de moisanita ---------- */
	var fuse = null;

	// Recorrido deliberadamente irregular: tramos largos, un looping que se cruza
	// sobre sí mismo hacia la mitad y remates asimétricos. Nada de zigzag regular.
	var FUSE_D =
		"M 74,-6 C 24,6 10,18 46,25 C 80,32 88,17 68,33 C 48,49 8,41 20,57 " +
		"C 29,69 57,61 61,51 C 65,41 47,43 45,55 C 43,72 85,70 72,83 " +
		"C 62,93 34,89 40,106";
	var TAIL = 0.17; // cola tenue, como fracción del recorrido total
	var HEAD = 0.045; // tramo encendido pegado a la punta

	function buildFuse() {
		if (!document.body.classList.contains("template-index")) return;
		if (document.querySelector(".he-fuse")) return;

		var wrap = document.createElement("div");
		wrap.className = "he-fuse";
		wrap.setAttribute("aria-hidden", "true");
		wrap.innerHTML =
			'<svg class="he-fuse__svg" viewBox="0 0 100 100" preserveAspectRatio="none">' +
			'<path class="he-fuse__trail" d="' + FUSE_D + '"/>' +
			'<path class="he-fuse__head" d="' + FUSE_D + '"/>' +
			"</svg>" +
			'<span class="he-fuse__tip"></span>';
		document.body.appendChild(wrap);

		var trail = wrap.querySelector(".he-fuse__trail");
		var head = wrap.querySelector(".he-fuse__head");
		var len = trail.getTotalLength();
		fuse = { trail: trail, head: head, tip: wrap.querySelector(".he-fuse__tip"), len: len };

		// dasharray "tramo, hueco enorme": solo se ve un trozo, no el recorrido entero
		trail.style.strokeDasharray = len * TAIL + " " + len * 4;
		head.style.strokeDasharray = len * HEAD + " " + len * 4;
	}

	function drawFuse(p) {
		if (!fuse) return;
		var L = fuse.len;
		// El trozo visible acaba justo en la punta: [p*L - tramo, p*L]
		fuse.trail.style.strokeDashoffset = L * TAIL - L * p;
		fuse.head.style.strokeDashoffset = L * HEAD - L * p;
		var pt = fuse.trail.getPointAtLength(L * p);
		// El viewBox es 0-100 y se estira al viewport: coordenada = porcentaje
		fuse.tip.style.left = pt.x + "%";
		fuse.tip.style.top = pt.y + "%";
		fuse.tip.classList.toggle("is-lit", p > 0.004 && p < 0.996);
	}

	/* ---------- init ---------- */
	function init(root) {
		decorate(root);
		collectParallax(root);
		buildFuse();
		if (!document.querySelector(".he-progress")) {
			var bar = document.createElement("div");
			bar.className = "he-progress";
			bar.setAttribute("aria-hidden", "true");
			document.body.appendChild(bar);
		}
		updateParallax();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			init(document);
		});
	} else {
		init(document);
	}

	window.addEventListener("scroll", onScroll, { passive: true });
	window.addEventListener("resize", onScroll, { passive: true });

	// Compatibilidad con el editor de temas
	document.addEventListener("shopify:section:load", function (e) {
		init(e.target);
	});
})();
